//Core
import React from "react"

//Components
import Blocks from "../../components/Blocks"
import Cards from "../../components/Cards"
import Header from "./Header"
import Button from "./Button"

//Images
import first from "../../images/bonus/first.jpg"
import second from "../../images/bonus/second.jpg"
import third from "../../images/bonus/third.jpg"

//Custom style components

const backgroundCards = { backgroundColor: "rgba(187, 187, 187, 0.15)" }
const titleStyle = {
  fontWeight: "bold",
  fontFamily: "GothamProMedium",
}

const Bonus = ({ bonus, link }) => {
  const blocks = [
    {
      img: first,
      title: `Для кого ця акція?`,
      subtitle: [`Персонально для Вас`],
    },
    {
      img: second,
      title: `Який подарунок я отримаю?`,
      subtitle: [
        `Бонус в розмірі ${bonus} грн буде зараховано на бонусний рахунок до 15.01.20 та 15.02.20`,
      ],
    },
    {
      img: third,
      title: `Як отримати подарунок?`,
      subtitle: [
        `Зробити покупку або зняти готівку до 31 січня 2020 карткою “Велика п’ятірка” або #PudraCard кредитними коштами на суму чеку від 500 грн`,
      ],
    },
  ]
  return (
    <div>
      <Header bonus={bonus}></Header>
      <Blocks items={blocks}></Blocks>
      <Cards
        info={false}
        background={backgroundCards}
        titleStyle={titleStyle}
      ></Cards>
      <Button
        title={"Пропозиція діє з 01 грудня 2019 по 31 січня 2020"}
        link={link}
      ></Button>
    </div>
  )
}

export default Bonus
